import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import type { RootState } from "../app/store";
import { resetAuth } from "../reducers/authSlice";
import { API_URL } from "../helpers";
import { generateSEKAndHash } from "./crypto";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState).auth;
    const { tempToken } = (getState() as RootState).auth;

    const encryptData = generateSEKAndHash(token || tempToken || null);

    if (encryptData) {
      headers.set("hash", encryptData?.hash);
      headers.set("sek", encryptData?.sek);
    }
    headers.set("deviceType", "web");
    // if (token) {
    //   headers.set("authorization", `Bearer ${token}`);
    // } else if (tempToken) {
    //   headers.set("authorization", `Bearer ${tempToken}`);
    // }
    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    //console.log({ errors });
    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }

    if (errors?.length) {
      const error = errors[0] as any;
      if (error?.length) {
        //console.log(error[0]);
      }
    }
  }
  if (result.error?.status === 401) {
    api.dispatch(resetAuth());
    if (window) {
      window.location.replace("/");
    }
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "UNAUTHORIZED",
    "UNKNOWN_ERROR",
    "GETAGENT",
    "GETCOMPANYREQ",
    "GETCOMPANY",
    "GETPROPERTY",
    "GETADS",
    "GETCATEGORY",
    "GETREELS",
    "GETAMEN",
    "GETPROPERTYTYPE",
    "GETPROPERTYSTATUS",
    "GETSUBSCRIPTION",
    "GETCHAT",
    "GETREVENUE",
    "GETEMAIL",
    "GETNOTIFICATION",
    "GETSETTINGS",
    "GETENQURIES",
    "GETFEEDBACKS",
    "GETCMS",
    "GETACTIONTRACKER",
    "LOCATION",
  ],
  endpoints: () => ({}),
});

export default emptySplitApi;
